import { useZIndexContext } from "@procore/core-react";

import { useAppSelector } from "app/redux-store-interactions";
import { selectOverlayElementsZIndex } from "slices/explorer";

/**
 * Returns the effective z-index value for overlay elements (modals, tearsheets, tooltips).
 *
 * Selects the maximum value from:
 * - Explicit `overlayElementsZIndex` from Webviewer initialization options
 * - Context value from `useZIndexContext()` (Procore ecosystem integration)
 * - Default minimum of 1050
 *
 * This ensures overlays appear above all potential sources of z-index values.
 *
 * @returns The maximum z-index value to use for overlay elements (minimum 1050)
 */
export function useOverlayZIndex(): number {
    const overlayElementsZIndex = useAppSelector(selectOverlayElementsZIndex);
    const zIndex = useZIndexContext();

    return Math.max(overlayElementsZIndex ?? 0, zIndex.value ?? 0, 1050);
}
